import { useIsIframeEmbed } from "@circle-react/hooks/useIsIframeEmbed";
import { useIsInsideMobileWebview } from "@circle-react/hooks/useIsInsideMobileWebview";
import { useTailwindLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

import { useBackendProps } from "@/react/providers/AppContext";

export const useIsAppBarVisible = () => {
  const isLargeScreen = useTailwindLgScreenMediaQuery();
  const isIframeEmbed = useIsIframeEmbed();
  const { display_header: shouldShowHeader, pages_app_page } =
    useBackendProps();
  const isInsideMobileWebview = useIsInsideMobileWebview();

  // If it's on a custom page, and the header is hidden, we don't want to show the app bar
  const shouldHideAppBarForPagesApp = pages_app_page && !shouldShowHeader;

  return (
    !isLargeScreen &&
    !isIframeEmbed &&
    !shouldHideAppBarForPagesApp &&
    !isInsideMobileWebview
  );
};
